"use strict";
// Generated with @bullhorn/bullhorn-cli
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityTypes = void 0;
// Utility Classes
var EntityTypes = /** @class */ (function () {
    function EntityTypes() {
    }
    EntityTypes.isSearchable = function (entity) {
        return ['Candidate', 'ClientContact', 'ClientCorporation', 'JobOrder', 'Opportunity', 'JobSubmission', 'Placement', 'Note', 'Task', 'Appointment'].indexOf(entity) >= 0;
    };
    EntityTypes.isSoftDelete = function (entity) {
        return ['ActivityGoalConfiguration', 'Appointment', 'BatchStatusLookup', 'BillableChargeStatusLookup', 'BillingProfile', 'BillingSyncBatchFileAttachment', 'Bot', 'BotCondition', 'BotOutcome', 'Branch', 'Candidate', 'CandidateCertification', 'CandidateEducation', 'CandidateFileAttachment', 'CandidateReference', 'CandidateWorkHistory', 'CanvasReport', 'CertificationRequirementStatusLookup', 'ChargeTypeLookup', 'CitySalesTaxRate', 'ClientContact', 'ClientContact1', 'ClientContact2', 'ClientContact3', 'ClientContact4', 'ClientContact5', 'ClientContactFileAttachment', 'ClientCorporationCertification', 'ClientCorporationFile', 'ClientCorporationFileAttachment', 'ClientCorporationLine', 'ClientCorporationRateAgreementCard', 'ClientCorporationTaxExemptionStatusLookup', 'CorporateUser', 'CountySalesTaxRate', 'CustomerRequiredFieldConfiguration', 'CustomerRequiredFieldValueTypeLookup', 'DefaultEarnCode', 'DiscountRate', 'DiscountTypeLookup', 'DistrictSalesTaxRate', 'DoubleTimeEarnCode', 'EarnCode', 'EarnCodeGroupStatusLookup', 'EarnCodeTypeLookup', 'EditHistoryActionLookup', 'EntityFieldTypeLookup', 'EntryTypeLookup', 'ExternalAccount', 'GeneralLedgerAccount', 'GeneralLedgerExportStatusLookup', 'GeneralLedgerSegment', 'GeneralLedgerSegment1', 'GeneralLedgerSegment2', 'GeneralLedgerSegment3', 'GeneralLedgerSegment4', 'GeneralLedgerSegment5', 'GeneralLedgerServiceCode', 'HitWord', 'Holiday', 'HolidayCategoryLookup', 'HolidayStatusLookup', 'HousingComplex', 'HousingComplexAmenity', 'HousingComplexFurnitureDelivery', 'HousingComplexUnit', 'HousingComplexUtilityAccount', 'InvoiceStatementDeliveryStatusLookup', 'InvoiceStatementLineDistributionTypeLookup', 'InvoiceStatementStatusLookup', 'InvoiceStatementTax', 'InvoiceStatementTypeLookup', 'InvoiceTerm', 'InvoiceTermTemplate', 'JobBoardPost', 'JobCode', 'JobOrder', 'JobOrder1', 'JobOrder2', 'JobOrder3', 'JobOrder4', 'JobOrder5', 'JobOrderFileAttachment', 'JobOrderRateCard', 'JobSubmission', 'Lead', 'Location', 'MassActionTypeLookup', 'Note', 'Opportunity', 'Opportunity1', 'Opportunity2', 'Opportunity3', 'Opportunity4', 'Opportunity5', 'OpportunityFileAttachment', 'OtherSalesTaxRate', 'OvertimeEarnCode', 'PayBillOptionsLookup', 'PayExportTypeLookup', 'PayGroupLookup', 'PayableChargeStatusLookup', 'PayrollEmployeeTypeLookup', 'PayrollExportTargetLookup', 'PayrollExportTypeLookup', 'PayrollSyncStatusLookup', 'Person', 'PlacementBillRuleset', 'PlacementFileAttachment', 'PlacementPayRuleset', 'PlacementRateCard', 'PlacementTaxExemptionStatusLookup', 'PulseConfigurationValue', 'RateDetail', 'RateGroup', 'ReportingCodeTemplate', 'SalesTaxRate', 'SalesTaxRateSourceLookup', 'SalesTaxRateTypeLookup', 'ShiftPosition', 'ShiftType', 'StateSalesTaxRate', 'StatusLookup', 'SurchargeRate', 'SurchargeRateTypeLookup', 'Task', 'TaxJurisdictionTypeLookup', 'TaxStatusLookup', 'TaxTypeLookup', 'Tearsheet', 'TimeLaborCalcTypeLookup', 'TimeLaborEvalDiffStatusLookup', 'TimeLaborEvalRuleCategoryLookup', 'TimeLaborEvalRuleCombineCriteriaLookup', 'TimeLaborEvalRuleStatusLookup', 'TimeLaborEvalRuleTypeLookup', 'TimeLaborEvalSheetEntryTypeLookup', 'TimeLaborEvalSheetStatusLookup', 'TimesheetEntryApprovalStatusLookup', 'UnitOfMeasure', 'UserConnectIntegrationStatusLookup', 'UserHousingComplexUnit', 'PlaceHolder'].indexOf(entity) >= 0;
    };
    EntityTypes.ActivityGoal = 'ActivityGoal';
    EntityTypes.ActivityGoalConfiguration = 'ActivityGoalConfiguration';
    EntityTypes.ActivityGoalTarget = 'ActivityGoalTarget';
    EntityTypes.AddressSource = 'AddressSource';
    EntityTypes.AllSalesTaxGroup = 'AllSalesTaxGroup';
    EntityTypes.AllSalesTaxRate = 'AllSalesTaxRate';
    EntityTypes.Application = 'Application';
    EntityTypes.Appointment = 'Appointment';
    EntityTypes.AppointmentAttendee = 'AppointmentAttendee';
    EntityTypes.AppointmentEditHistory = 'AppointmentEditHistory';
    EntityTypes.AppointmentEditHistoryFieldChange = 'AppointmentEditHistoryFieldChange';
    EntityTypes.AppointmentTemplate = 'AppointmentTemplate';
    EntityTypes.AutoAddBlacklistDomain = 'AutoAddBlacklistDomain';
    EntityTypes.BatchGroup = 'BatchGroup';
    EntityTypes.BatchStatusLookup = 'BatchStatusLookup';
    EntityTypes.BillMaster = 'BillMaster';
    EntityTypes.BillMasterCustomerRequiredField = 'BillMasterCustomerRequiredField';
    EntityTypes.BillMasterCustomerRequiredFields = 'BillMasterCustomerRequiredFields';
    EntityTypes.BillMasterDiscountRate = 'BillMasterDiscountRate';
    EntityTypes.BillMasterSurchargeRate = 'BillMasterSurchargeRate';
    EntityTypes.BillMasterSyncBatch = 'BillMasterSyncBatch';
    EntityTypes.BillMasterTransaction = 'BillMasterTransaction';
    EntityTypes.BillMasterTransactionDiscountRate = 'BillMasterTransactionDiscountRate';
    EntityTypes.BillMasterTransactionDistributionBatch = 'BillMasterTransactionDistributionBatch';
    EntityTypes.BillMasterTransactionSalesTaxRate = 'BillMasterTransactionSalesTaxRate';
    EntityTypes.BillMasterTransactionSurchargeRate = 'BillMasterTransactionSurchargeRate';
    EntityTypes.BillTransaction = 'BillTransaction';
    EntityTypes.BillableCharge = 'BillableCharge';
    EntityTypes.BillableChargeBillableTransaction = 'BillableChargeBillableTransaction';
    EntityTypes.BillableChargeEditHistory = 'BillableChargeEditHistory';
    EntityTypes.BillableChargeEditHistoryFieldChange = 'BillableChargeEditHistoryFieldChange';
    EntityTypes.BillableChargeFileAttachment = 'BillableChargeFileAttachment';
    EntityTypes.BillableChargeInvoicedTransaction = 'BillableChargeInvoicedTransaction';
    EntityTypes.BillableChargeStatusLookup = 'BillableChargeStatusLookup';
    EntityTypes.BillableChargeSummaryTransaction = 'BillableChargeSummaryTransaction';
    EntityTypes.BillableChargeUnbillableTransaction = 'BillableChargeUnbillableTransaction';
    EntityTypes.BillingProfile = 'BillingProfile';
    EntityTypes.BillingProfileEditHistory = 'BillingProfileEditHistory';
    EntityTypes.BillingProfileEditHistoryFieldChange = 'BillingProfileEditHistoryFieldChange';
    EntityTypes.BillingProfileEffectiveDateChange = 'BillingProfileEffectiveDateChange';
    EntityTypes.BillingProfileVersion = 'BillingProfileVersion';
    EntityTypes.BillingSyncBatch = 'BillingSyncBatch';
    EntityTypes.BillingSyncBatchFileAttachment = 'BillingSyncBatchFileAttachment';
    EntityTypes.BillingSyncError = 'BillingSyncError';
    EntityTypes.Bot = 'Bot';
    EntityTypes.BotCondition = 'BotCondition';
    EntityTypes.BotExecutionHistory = 'BotExecutionHistory';
    EntityTypes.BotOutcome = 'BotOutcome';
    EntityTypes.Branch = 'Branch';
    EntityTypes.BusinessSector = 'BusinessSector';
    EntityTypes.Calendar = 'Calendar';
    EntityTypes.CalendarFrequencyLookup = 'CalendarFrequencyLookup';
    EntityTypes.CalendarInstance = 'CalendarInstance';
    EntityTypes.Candidate = 'Candidate';
    EntityTypes.CandidateAvailability = 'CandidateAvailability';
    EntityTypes.CandidateCertification = 'CandidateCertification';
    EntityTypes.CandidateCertificationEditHistory = 'CandidateCertificationEditHistory';
    EntityTypes.CandidateCertificationEditHistoryFieldChange = 'CandidateCertificationEditHistoryFieldChange';
    EntityTypes.CandidateCertificationRequirement = 'CandidateCertificationRequirement';
    EntityTypes.CandidateCertificationRequirementEditHistory = 'CandidateCertificationRequirementEditHistory';
    EntityTypes.CandidateCertificationRequirementEditHistoryFieldChange = 'CandidateCertificationRequirementEditHistoryFieldChange';
    EntityTypes.CandidateComment = 'CandidateComment';
    EntityTypes.CandidateEducation = 'CandidateEducation';
    EntityTypes.CandidateFileAttachment = 'CandidateFileAttachment';
    EntityTypes.CandidateHistory = 'CandidateHistory';
    EntityTypes.CandidateReference = 'CandidateReference';
    EntityTypes.CandidateReferenceQuestion = 'CandidateReferenceQuestion';
    EntityTypes.CandidateReferenceResponse = 'CandidateReferenceResponse';
    EntityTypes.CandidateShiftPreference = 'CandidateShiftPreference';
    EntityTypes.CandidateSource = 'CandidateSource';
    EntityTypes.CandidateTaxInfo = 'CandidateTaxInfo';
    EntityTypes.CandidateWorkHistory = 'CandidateWorkHistory';
    EntityTypes.CanvasReport = 'CanvasReport';
    EntityTypes.CanvasScheduledReport = 'CanvasScheduledReport';
    EntityTypes.Card = 'Card';
    EntityTypes.CardCategory = 'CardCategory';
    EntityTypes.Category = 'Category';
    EntityTypes.Certification = 'Certification';
    EntityTypes.CertificationFileAttachment = 'CertificationFileAttachment';
    EntityTypes.CertificationGroup = 'CertificationGroup';
    EntityTypes.CertificationRequirement = 'CertificationRequirement';
    EntityTypes.CertificationRequirementStatusLookup = 'CertificationRequirementStatusLookup';
    EntityTypes.ChargeTypeLookup = 'ChargeTypeLookup';
    EntityTypes.CitySalesTaxRate = 'CitySalesTaxRate';
    EntityTypes.ClientContact = 'ClientContact';
    EntityTypes.ClientContact1 = 'ClientContact1';
    EntityTypes.ClientContact2 = 'ClientContact2';
    EntityTypes.ClientContact3 = 'ClientContact3';
    EntityTypes.ClientContact4 = 'ClientContact4';
    EntityTypes.ClientContact5 = 'ClientContact5';
    EntityTypes.ClientContactFileAttachment = 'ClientContactFileAttachment';
    EntityTypes.ClientContactHistory = 'ClientContactHistory';
    EntityTypes.ClientContactRatios = 'ClientContactRatios';
    EntityTypes.ClientCorporation = 'ClientCorporation';
    EntityTypes.ClientCorporation1 = 'ClientCorporation1';
    EntityTypes.ClientCorporation2 = 'ClientCorporation2';
    EntityTypes.ClientCorporation3 = 'ClientCorporation3';
    EntityTypes.ClientCorporation4 = 'ClientCorporation4';
    EntityTypes.ClientCorporation5 = 'ClientCorporation5';
    EntityTypes.ClientCorporationAppointment = 'ClientCorporationAppointment';
    EntityTypes.ClientCorporationBillRuleset = 'ClientCorporationBillRuleset';
    EntityTypes.ClientCorporationBillRulesetAssociationChangeHistory = 'ClientCorporationBillRulesetAssociationChangeHistory';
    EntityTypes.ClientCorporationBillRulesetEditHistory = 'ClientCorporationBillRulesetEditHistory';
    EntityTypes.ClientCorporationBillRulesetEditHistoryFieldChange = 'ClientCorporationBillRulesetEditHistoryFieldChange';
    EntityTypes.ClientCorporationBillRulesetEffectiveDateChange = 'ClientCorporationBillRulesetEffectiveDateChange';
    EntityTypes.ClientCorporationCertification = 'ClientCorporationCertification';
    EntityTypes.ClientCorporationCustomObject = 'ClientCorporationCustomObject';
    EntityTypes.ClientCorporationCustomObject10EditHistory = 'ClientCorporationCustomObject10EditHistory';
    EntityTypes.ClientCorporationCustomObject11EditHistory = 'ClientCorporationCustomObject11EditHistory';
    EntityTypes.ClientCorporationCustomObject12EditHistory = 'ClientCorporationCustomObject12EditHistory';
    EntityTypes.ClientCorporationCustomObject13EditHistory = 'ClientCorporationCustomObject13EditHistory';
    EntityTypes.ClientCorporationCustomObject14EditHistory = 'ClientCorporationCustomObject14EditHistory';
    EntityTypes.ClientCorporationCustomObject15EditHistory = 'ClientCorporationCustomObject15EditHistory';
    EntityTypes.ClientCorporationCustomObject16EditHistory = 'ClientCorporationCustomObject16EditHistory';
    EntityTypes.ClientCorporationCustomObject17EditHistory = 'ClientCorporationCustomObject17EditHistory';
    EntityTypes.ClientCorporationCustomObject18EditHistory = 'ClientCorporationCustomObject18EditHistory';
    EntityTypes.ClientCorporationCustomObject19EditHistory = 'ClientCorporationCustomObject19EditHistory';
    EntityTypes.ClientCorporationCustomObject1EditHistory = 'ClientCorporationCustomObject1EditHistory';
    EntityTypes.ClientCorporationCustomObject20EditHistory = 'ClientCorporationCustomObject20EditHistory';
    EntityTypes.ClientCorporationCustomObject21EditHistory = 'ClientCorporationCustomObject21EditHistory';
    EntityTypes.ClientCorporationCustomObject22EditHistory = 'ClientCorporationCustomObject22EditHistory';
    EntityTypes.ClientCorporationCustomObject23EditHistory = 'ClientCorporationCustomObject23EditHistory';
    EntityTypes.ClientCorporationCustomObject24EditHistory = 'ClientCorporationCustomObject24EditHistory';
    EntityTypes.ClientCorporationCustomObject25EditHistory = 'ClientCorporationCustomObject25EditHistory';
    EntityTypes.ClientCorporationCustomObject26EditHistory = 'ClientCorporationCustomObject26EditHistory';
    EntityTypes.ClientCorporationCustomObject27EditHistory = 'ClientCorporationCustomObject27EditHistory';
    EntityTypes.ClientCorporationCustomObject28EditHistory = 'ClientCorporationCustomObject28EditHistory';
    EntityTypes.ClientCorporationCustomObject29EditHistory = 'ClientCorporationCustomObject29EditHistory';
    EntityTypes.ClientCorporationCustomObject2EditHistory = 'ClientCorporationCustomObject2EditHistory';
    EntityTypes.ClientCorporationCustomObject30EditHistory = 'ClientCorporationCustomObject30EditHistory';
    EntityTypes.ClientCorporationCustomObject31EditHistory = 'ClientCorporationCustomObject31EditHistory';
    EntityTypes.ClientCorporationCustomObject32EditHistory = 'ClientCorporationCustomObject32EditHistory';
    EntityTypes.ClientCorporationCustomObject33EditHistory = 'ClientCorporationCustomObject33EditHistory';
    EntityTypes.ClientCorporationCustomObject34EditHistory = 'ClientCorporationCustomObject34EditHistory';
    EntityTypes.ClientCorporationCustomObject35EditHistory = 'ClientCorporationCustomObject35EditHistory';
    EntityTypes.ClientCorporationCustomObject3EditHistory = 'ClientCorporationCustomObject3EditHistory';
    EntityTypes.ClientCorporationCustomObject4EditHistory = 'ClientCorporationCustomObject4EditHistory';
    EntityTypes.ClientCorporationCustomObject5EditHistory = 'ClientCorporationCustomObject5EditHistory';
    EntityTypes.ClientCorporationCustomObject6EditHistory = 'ClientCorporationCustomObject6EditHistory';
    EntityTypes.ClientCorporationCustomObject7EditHistory = 'ClientCorporationCustomObject7EditHistory';
    EntityTypes.ClientCorporationCustomObject8EditHistory = 'ClientCorporationCustomObject8EditHistory';
    EntityTypes.ClientCorporationCustomObject9EditHistory = 'ClientCorporationCustomObject9EditHistory';
    EntityTypes.ClientCorporationCustomObjectAttribute = 'ClientCorporationCustomObjectAttribute';
    EntityTypes.ClientCorporationCustomObjectAttributeInteraction = 'ClientCorporationCustomObjectAttributeInteraction';
    EntityTypes.ClientCorporationCustomObjectDepartment = 'ClientCorporationCustomObjectDepartment';
    EntityTypes.ClientCorporationCustomObjectEditHistoryFieldChange = 'ClientCorporationCustomObjectEditHistoryFieldChange';
    EntityTypes.ClientCorporationCustomObjectInstance1 = 'ClientCorporationCustomObjectInstance1';
    EntityTypes.ClientCorporationCustomObjectInstance10 = 'ClientCorporationCustomObjectInstance10';
    EntityTypes.ClientCorporationCustomObjectInstance11 = 'ClientCorporationCustomObjectInstance11';
    EntityTypes.ClientCorporationCustomObjectInstance12 = 'ClientCorporationCustomObjectInstance12';
    EntityTypes.ClientCorporationCustomObjectInstance13 = 'ClientCorporationCustomObjectInstance13';
    EntityTypes.ClientCorporationCustomObjectInstance14 = 'ClientCorporationCustomObjectInstance14';
    EntityTypes.ClientCorporationCustomObjectInstance15 = 'ClientCorporationCustomObjectInstance15';
    EntityTypes.ClientCorporationCustomObjectInstance16 = 'ClientCorporationCustomObjectInstance16';
    EntityTypes.ClientCorporationCustomObjectInstance17 = 'ClientCorporationCustomObjectInstance17';
    EntityTypes.ClientCorporationCustomObjectInstance18 = 'ClientCorporationCustomObjectInstance18';
    EntityTypes.ClientCorporationCustomObjectInstance19 = 'ClientCorporationCustomObjectInstance19';
    EntityTypes.ClientCorporationCustomObjectInstance2 = 'ClientCorporationCustomObjectInstance2';
    EntityTypes.ClientCorporationCustomObjectInstance20 = 'ClientCorporationCustomObjectInstance20';
    EntityTypes.ClientCorporationCustomObjectInstance21 = 'ClientCorporationCustomObjectInstance21';
    EntityTypes.ClientCorporationCustomObjectInstance22 = 'ClientCorporationCustomObjectInstance22';
    EntityTypes.ClientCorporationCustomObjectInstance23 = 'ClientCorporationCustomObjectInstance23';
    EntityTypes.ClientCorporationCustomObjectInstance24 = 'ClientCorporationCustomObjectInstance24';
    EntityTypes.ClientCorporationCustomObjectInstance25 = 'ClientCorporationCustomObjectInstance25';
    EntityTypes.ClientCorporationCustomObjectInstance26 = 'ClientCorporationCustomObjectInstance26';
    EntityTypes.ClientCorporationCustomObjectInstance27 = 'ClientCorporationCustomObjectInstance27';
    EntityTypes.ClientCorporationCustomObjectInstance28 = 'ClientCorporationCustomObjectInstance28';
    EntityTypes.ClientCorporationCustomObjectInstance29 = 'ClientCorporationCustomObjectInstance29';
    EntityTypes.ClientCorporationCustomObjectInstance3 = 'ClientCorporationCustomObjectInstance3';
    EntityTypes.ClientCorporationCustomObjectInstance30 = 'ClientCorporationCustomObjectInstance30';
    EntityTypes.ClientCorporationCustomObjectInstance31 = 'ClientCorporationCustomObjectInstance31';
    EntityTypes.ClientCorporationCustomObjectInstance32 = 'ClientCorporationCustomObjectInstance32';
    EntityTypes.ClientCorporationCustomObjectInstance33 = 'ClientCorporationCustomObjectInstance33';
    EntityTypes.ClientCorporationCustomObjectInstance34 = 'ClientCorporationCustomObjectInstance34';
    EntityTypes.ClientCorporationCustomObjectInstance35 = 'ClientCorporationCustomObjectInstance35';
    EntityTypes.ClientCorporationCustomObjectInstance4 = 'ClientCorporationCustomObjectInstance4';
    EntityTypes.ClientCorporationCustomObjectInstance5 = 'ClientCorporationCustomObjectInstance5';
    EntityTypes.ClientCorporationCustomObjectInstance6 = 'ClientCorporationCustomObjectInstance6';
    EntityTypes.ClientCorporationCustomObjectInstance7 = 'ClientCorporationCustomObjectInstance7';
    EntityTypes.ClientCorporationCustomObjectInstance8 = 'ClientCorporationCustomObjectInstance8';
    EntityTypes.ClientCorporationCustomObjectInstance9 = 'ClientCorporationCustomObjectInstance9';
    EntityTypes.ClientCorporationEditHistory = 'ClientCorporationEditHistory';
    EntityTypes.ClientCorporationEditHistoryFieldChange = 'ClientCorporationEditHistoryFieldChange';
    EntityTypes.ClientCorporationFile = 'ClientCorporationFile';
    EntityTypes.ClientCorporationFileAttachment = 'ClientCorporationFileAttachment';
    EntityTypes.ClientCorporationHistory = 'ClientCorporationHistory';
    EntityTypes.ClientCorporationLine = 'ClientCorporationLine';
    EntityTypes.ClientCorporationLineEditHistory = 'ClientCorporationLineEditHistory';
    EntityTypes.ClientCorporationLineEditHistoryFieldChange = 'ClientCorporationLineEditHistoryFieldChange';
    EntityTypes.ClientCorporationNote = 'ClientCorporationNote';
    EntityTypes.ClientCorporationPayRuleset = 'ClientCorporationPayRuleset';
    EntityTypes.ClientCorporationPayRulesetAssociationChangeHistory = 'ClientCorporationPayRulesetAssociationChangeHistory';
    EntityTypes.ClientCorporationPayRulesetEditHistory = 'ClientCorporationPayRulesetEditHistory';
    EntityTypes.ClientCorporationPayRulesetEditHistoryFieldChange = 'ClientCorporationPayRulesetEditHistoryFieldChange';
    EntityTypes.ClientCorporationPayRulesetEffectiveDateChange = 'ClientCorporationPayRulesetEffectiveDateChange';
    EntityTypes.ClientCorporationRateAgreementCard = 'ClientCorporationRateAgreementCard';
    EntityTypes.ClientCorporationRateAgreementCardEditHistory = 'ClientCorporationRateAgreementCardEditHistory';
    EntityTypes.ClientCorporationRateAgreementCardEditHistoryFieldChange = 'ClientCorporationRateAgreementCardEditHistoryFieldChange';
    EntityTypes.ClientCorporationRateAgreementCardEffectiveDateChange = 'ClientCorporationRateAgreementCardEffectiveDateChange';
    EntityTypes.ClientCorporationRateAgreementCardLine = 'ClientCorporationRateAgreementCardLine';
    EntityTypes.ClientCorporationRateAgreementCardLineEditHistoryFieldChange = 'ClientCorporationRateAgreementCardLineEditHistoryFieldChange';
    EntityTypes.ClientCorporationRateAgreementCardLineGroup = 'ClientCorporationRateAgreementCardLineGroup';
    EntityTypes.ClientCorporationRateAgreementCardLineGroupEditHistoryFieldChange = 'ClientCorporationRateAgreementCardLineGroupEditHistoryFieldChange';
    EntityTypes.ClientCorporationRateAgreementCardVersion = 'ClientCorporationRateAgreementCardVersion';
    EntityTypes.ClientCorporationRatios = 'ClientCorporationRatios';
    EntityTypes.ClientCorporationTask = 'ClientCorporationTask';
    EntityTypes.ClientCorporationTaxExemptionStatusLookup = 'ClientCorporationTaxExemptionStatusLookup';
    EntityTypes.ComposeMessage = 'ComposeMessage';
    EntityTypes.CorpFile = 'CorpFile';
    EntityTypes.CorporateUser = 'CorporateUser';
    EntityTypes.Corporation = 'Corporation';
    EntityTypes.CorporationDepartment = 'CorporationDepartment';
    EntityTypes.CorporationGDPRCompliance = 'CorporationGDPRCompliance';
    EntityTypes.Country = 'Country';
    EntityTypes.CountySalesTaxRate = 'CountySalesTaxRate';
    EntityTypes.CurrencyUnit = 'CurrencyUnit';
    EntityTypes.CustomAction = 'CustomAction';
    EntityTypes.CustomListButton = 'CustomListButton';
    EntityTypes.CustomerRequiredFieldConfiguration = 'CustomerRequiredFieldConfiguration';
    EntityTypes.CustomerRequiredFieldConfigurationVersion = 'CustomerRequiredFieldConfigurationVersion';
    EntityTypes.CustomerRequiredFieldConfigurationVersionOption = 'CustomerRequiredFieldConfigurationVersionOption';
    EntityTypes.CustomerRequiredFieldMeta = 'CustomerRequiredFieldMeta';
    EntityTypes.CustomerRequiredFieldMetaEditHistory = 'CustomerRequiredFieldMetaEditHistory';
    EntityTypes.CustomerRequiredFieldMetaEditHistoryFieldChange = 'CustomerRequiredFieldMetaEditHistoryFieldChange';
    EntityTypes.CustomerRequiredFieldOption = 'CustomerRequiredFieldOption';
    EntityTypes.CustomerRequiredFieldOptionEditHistory = 'CustomerRequiredFieldOptionEditHistory';
    EntityTypes.CustomerRequiredFieldOptionEditHistoryFieldChange = 'CustomerRequiredFieldOptionEditHistoryFieldChange';
    EntityTypes.CustomerRequiredFieldValueTypeLookup = 'CustomerRequiredFieldValueTypeLookup';
    EntityTypes.Dashboard = 'Dashboard';
    EntityTypes.Deduction = 'Deduction';
    EntityTypes.DeductionCategoryLookup = 'DeductionCategoryLookup';
    EntityTypes.DefaultEarnCode = 'DefaultEarnCode';
    EntityTypes.Department = 'Department';
    EntityTypes.Discount = 'Discount';
    EntityTypes.DiscountEditHistory = 'DiscountEditHistory';
    EntityTypes.DiscountEditHistoryFieldChange = 'DiscountEditHistoryFieldChange';
    EntityTypes.DiscountRate = 'DiscountRate';
    EntityTypes.DiscountRateAssociationChangeHistory = 'DiscountRateAssociationChangeHistory';
    EntityTypes.DiscountRateEditHistory = 'DiscountRateEditHistory';
    EntityTypes.DiscountRateEditHistoryFieldChange = 'DiscountRateEditHistoryFieldChange';
    EntityTypes.DiscountRateEffectiveDateChange = 'DiscountRateEffectiveDateChange';
    EntityTypes.DiscountRateVersion = 'DiscountRateVersion';
    EntityTypes.DiscountType = 'DiscountType';
    EntityTypes.DiscountTypeLookup = 'DiscountTypeLookup';
    EntityTypes.DistributionList = 'DistributionList';
    EntityTypes.DistrictSalesTaxRate = 'DistrictSalesTaxRate';
    EntityTypes.DoubleTimeEarnCode = 'DoubleTimeEarnCode';
    EntityTypes.EarnCode = 'EarnCode';
    EntityTypes.EarnCodeEditHistory = 'EarnCodeEditHistory';
    EntityTypes.EarnCodeEditHistoryFieldChange = 'EarnCodeEditHistoryFieldChange';
    EntityTypes.EarnCodeGroup = 'EarnCodeGroup';
    EntityTypes.EarnCodeGroupStatusLookup = 'EarnCodeGroupStatusLookup';
    EntityTypes.EarnCodeTemplate = 'EarnCodeTemplate';
    EntityTypes.EarnCodeTypeLookup = 'EarnCodeTypeLookup';
    EntityTypes.EditHistoryActionLookup = 'EditHistoryActionLookup';
    EntityTypes.EmailHitWordMatch = 'EmailHitWordMatch';
    EntityTypes.EmailHitWordMatchDetail = 'EmailHitWordMatchDetail';
    EntityTypes.EmailTemplate = 'EmailTemplate';
    EntityTypes.EmployeePay = 'EmployeePay';
    EntityTypes.EmployerContribution = 'EmployerContribution';
    EntityTypes.EntityFieldTypeLookup = 'EntityFieldTypeLookup';
    EntityTypes.EntryTypeLookup = 'EntryTypeLookup';
    EntityTypes.EstaffMappableFlowback = 'EstaffMappableFlowback';
    EntityTypes.ExpenseSheet = 'ExpenseSheet';
    EntityTypes.ExpenseSheetEntry = 'ExpenseSheetEntry';
    EntityTypes.ExpenseSheetEntryApprovalStatusLookup = 'ExpenseSheetEntryApprovalStatusLookup';
    EntityTypes.ExternalAccount = 'ExternalAccount';
    EntityTypes.ExternalAccountProfile = 'ExternalAccountProfile';
    EntityTypes.ExternalBatchStatusRequest = 'ExternalBatchStatusRequest';
    EntityTypes.ExternalSystem = 'ExternalSystem';
    EntityTypes.FederalTaxForm = 'FederalTaxForm';
    EntityTypes.FieldMapInteraction = 'FieldMapInteraction';
    EntityTypes.File = 'File';
    EntityTypes.FormTrigger = 'FormTrigger';
    EntityTypes.FormTriggerEvent = 'FormTriggerEvent';
    EntityTypes.FormTriggerFull = 'FormTriggerFull';
    EntityTypes.FormTriggerInstance = 'FormTriggerInstance';
    EntityTypes.FormTriggerMessage = 'FormTriggerMessage';
    EntityTypes.GDPRDeletionRequest = 'GDPRDeletionRequest';
    EntityTypes.GeneralLedgerAccount = 'GeneralLedgerAccount';
    EntityTypes.GeneralLedgerExportStatusLookup = 'GeneralLedgerExportStatusLookup';
    EntityTypes.GeneralLedgerSegment = 'GeneralLedgerSegment';
    EntityTypes.GeneralLedgerSegment1 = 'GeneralLedgerSegment1';
    EntityTypes.GeneralLedgerSegment2 = 'GeneralLedgerSegment2';
    EntityTypes.GeneralLedgerSegment3 = 'GeneralLedgerSegment3';
    EntityTypes.GeneralLedgerSegment4 = 'GeneralLedgerSegment4';
    EntityTypes.GeneralLedgerSegment5 = 'GeneralLedgerSegment5';
    EntityTypes.GeneralLedgerSegmentType = 'GeneralLedgerSegmentType';
    EntityTypes.GeneralLedgerServiceCode = 'GeneralLedgerServiceCode';
    EntityTypes.GoalTarget = 'GoalTarget';
    EntityTypes.HitWord = 'HitWord';
    EntityTypes.Holiday = 'Holiday';
    EntityTypes.HolidayCategoryLookup = 'HolidayCategoryLookup';
    EntityTypes.HolidayInstance = 'HolidayInstance';
    EntityTypes.HolidayStatusLookup = 'HolidayStatusLookup';
    EntityTypes.HousingComplex = 'HousingComplex';
    EntityTypes.HousingComplexAmenity = 'HousingComplexAmenity';
    EntityTypes.HousingComplexFurnitureDelivery = 'HousingComplexFurnitureDelivery';
    EntityTypes.HousingComplexUnit = 'HousingComplexUnit';
    EntityTypes.HousingComplexUtilityAccount = 'HousingComplexUtilityAccount';
    EntityTypes.InvoicePayment = 'InvoicePayment';
    EntityTypes.InvoiceStatement = 'InvoiceStatement';
    EntityTypes.InvoiceStatementBatch = 'InvoiceStatementBatch';
    EntityTypes.InvoiceStatementDeliveryStatusLookup = 'InvoiceStatementDeliveryStatusLookup';
    EntityTypes.InvoiceStatementDiscount = 'InvoiceStatementDiscount';
    EntityTypes.InvoiceStatementDistributionBatch = 'InvoiceStatementDistributionBatch';
    EntityTypes.InvoiceStatementEditHistory = 'InvoiceStatementEditHistory';
    EntityTypes.InvoiceStatementEditHistoryAssociationChange = 'InvoiceStatementEditHistoryAssociationChange';
    EntityTypes.InvoiceStatementEditHistoryFieldChange = 'InvoiceStatementEditHistoryFieldChange';
    EntityTypes.InvoiceStatementEmailBatch = 'InvoiceStatementEmailBatch';
    EntityTypes.InvoiceStatementExport = 'InvoiceStatementExport';
    EntityTypes.InvoiceStatementExportBatch = 'InvoiceStatementExportBatch';
    EntityTypes.InvoiceStatementHistory = 'InvoiceStatementHistory';
    EntityTypes.InvoiceStatementLineDistribution = 'InvoiceStatementLineDistribution';
    EntityTypes.InvoiceStatementLineDistributionTypeLookup = 'InvoiceStatementLineDistributionTypeLookup';
    EntityTypes.InvoiceStatementLineItem = 'InvoiceStatementLineItem';
    EntityTypes.InvoiceStatementLineItemEditHistory = 'InvoiceStatementLineItemEditHistory';
    EntityTypes.InvoiceStatementLineItemEditHistoryFieldChange = 'InvoiceStatementLineItemEditHistoryFieldChange';
    EntityTypes.InvoiceStatementLineItemGroupBy = 'InvoiceStatementLineItemGroupBy';
    EntityTypes.InvoiceStatementLineItemSummarizeBy = 'InvoiceStatementLineItemSummarizeBy';
    EntityTypes.InvoiceStatementMessageTemplate = 'InvoiceStatementMessageTemplate';
    EntityTypes.InvoiceStatementNumberFormat = 'InvoiceStatementNumberFormat';
    EntityTypes.InvoiceStatementSplitBy = 'InvoiceStatementSplitBy';
    EntityTypes.InvoiceStatementStatusLookup = 'InvoiceStatementStatusLookup';
    EntityTypes.InvoiceStatementSurcharge = 'InvoiceStatementSurcharge';
    EntityTypes.InvoiceStatementTax = 'InvoiceStatementTax';
    EntityTypes.InvoiceStatementTemplate = 'InvoiceStatementTemplate';
    EntityTypes.InvoiceStatementTypeLookup = 'InvoiceStatementTypeLookup';
    EntityTypes.InvoiceTerm = 'InvoiceTerm';
    EntityTypes.InvoiceTermConfiguration = 'InvoiceTermConfiguration';
    EntityTypes.InvoiceTermConfigurationOptInField = 'InvoiceTermConfigurationOptInField';
    EntityTypes.InvoiceTermEditHistory = 'InvoiceTermEditHistory';
    EntityTypes.InvoiceTermEditHistoryFieldChange = 'InvoiceTermEditHistoryFieldChange';
    EntityTypes.InvoiceTermEffectiveDateChange = 'InvoiceTermEffectiveDateChange';
    EntityTypes.InvoiceTermTemplate = 'InvoiceTermTemplate';
    EntityTypes.InvoiceTermVersion = 'InvoiceTermVersion';
    EntityTypes.Issue = 'Issue';
    EntityTypes.IssueItems = 'IssueItems';
    EntityTypes.IssueResolutionStatusLookup = 'IssueResolutionStatusLookup';
    EntityTypes.JobBoardHistory = 'JobBoardHistory';
    EntityTypes.JobBoardJobOrder = 'JobBoardJobOrder';
    EntityTypes.JobBoardPost = 'JobBoardPost';
    EntityTypes.JobCode = 'JobCode';
    EntityTypes.JobCodeEditHistory = 'JobCodeEditHistory';
    EntityTypes.JobCodeEditHistoryFieldChange = 'JobCodeEditHistoryFieldChange';
    EntityTypes.JobOrder = 'JobOrder';
    EntityTypes.JobOrder1 = 'JobOrder1';
    EntityTypes.JobOrder2 = 'JobOrder2';
    EntityTypes.JobOrder3 = 'JobOrder3';
    EntityTypes.JobOrder4 = 'JobOrder4';
    EntityTypes.JobOrder5 = 'JobOrder5';
    EntityTypes.JobOrderBillRuleset = 'JobOrderBillRuleset';
    EntityTypes.JobOrderBillRulesetAssociationChangeHistory = 'JobOrderBillRulesetAssociationChangeHistory';
    EntityTypes.JobOrderBillRulesetEditHistory = 'JobOrderBillRulesetEditHistory';
    EntityTypes.JobOrderBillRulesetEditHistoryFieldChange = 'JobOrderBillRulesetEditHistoryFieldChange';
    EntityTypes.JobOrderBillRulesetEffectiveDateChange = 'JobOrderBillRulesetEffectiveDateChange';
    EntityTypes.JobOrderCustomObject = 'JobOrderCustomObject';
    EntityTypes.JobOrderCustomObject10EditHistory = 'JobOrderCustomObject10EditHistory';
    EntityTypes.JobOrderCustomObject1EditHistory = 'JobOrderCustomObject1EditHistory';
    EntityTypes.JobOrderCustomObject2EditHistory = 'JobOrderCustomObject2EditHistory';
    EntityTypes.JobOrderCustomObject3EditHistory = 'JobOrderCustomObject3EditHistory';
    EntityTypes.JobOrderCustomObject4EditHistory = 'JobOrderCustomObject4EditHistory';
    EntityTypes.JobOrderCustomObject5EditHistory = 'JobOrderCustomObject5EditHistory';
    EntityTypes.JobOrderCustomObject6EditHistory = 'JobOrderCustomObject6EditHistory';
    EntityTypes.JobOrderCustomObject7EditHistory = 'JobOrderCustomObject7EditHistory';
    EntityTypes.JobOrderCustomObject8EditHistory = 'JobOrderCustomObject8EditHistory';
    EntityTypes.JobOrderCustomObject9EditHistory = 'JobOrderCustomObject9EditHistory';
    EntityTypes.JobOrderCustomObjectAttribute = 'JobOrderCustomObjectAttribute';
    EntityTypes.JobOrderCustomObjectAttributeInteraction = 'JobOrderCustomObjectAttributeInteraction';
    EntityTypes.JobOrderCustomObjectDepartment = 'JobOrderCustomObjectDepartment';
    EntityTypes.JobOrderCustomObjectEditHistoryFieldChange = 'JobOrderCustomObjectEditHistoryFieldChange';
    EntityTypes.JobOrderCustomObjectInstance1 = 'JobOrderCustomObjectInstance1';
    EntityTypes.JobOrderCustomObjectInstance10 = 'JobOrderCustomObjectInstance10';
    EntityTypes.JobOrderCustomObjectInstance2 = 'JobOrderCustomObjectInstance2';
    EntityTypes.JobOrderCustomObjectInstance3 = 'JobOrderCustomObjectInstance3';
    EntityTypes.JobOrderCustomObjectInstance4 = 'JobOrderCustomObjectInstance4';
    EntityTypes.JobOrderCustomObjectInstance5 = 'JobOrderCustomObjectInstance5';
    EntityTypes.JobOrderCustomObjectInstance6 = 'JobOrderCustomObjectInstance6';
    EntityTypes.JobOrderCustomObjectInstance7 = 'JobOrderCustomObjectInstance7';
    EntityTypes.JobOrderCustomObjectInstance8 = 'JobOrderCustomObjectInstance8';
    EntityTypes.JobOrderCustomObjectInstance9 = 'JobOrderCustomObjectInstance9';
    EntityTypes.JobOrderEditHistory = 'JobOrderEditHistory';
    EntityTypes.JobOrderEditHistoryFieldChange = 'JobOrderEditHistoryFieldChange';
    EntityTypes.JobOrderFileAttachment = 'JobOrderFileAttachment';
    EntityTypes.JobOrderHistory = 'JobOrderHistory';
    EntityTypes.JobOrderIntegration = 'JobOrderIntegration';
    EntityTypes.JobOrderPayRuleset = 'JobOrderPayRuleset';
    EntityTypes.JobOrderPayRulesetAssociationChangeHistory = 'JobOrderPayRulesetAssociationChangeHistory';
    EntityTypes.JobOrderPayRulesetEditHistory = 'JobOrderPayRulesetEditHistory';
    EntityTypes.JobOrderPayRulesetEditHistoryFieldChange = 'JobOrderPayRulesetEditHistoryFieldChange';
    EntityTypes.JobOrderPayRulesetEffectiveDateChange = 'JobOrderPayRulesetEffectiveDateChange';
    EntityTypes.JobOrderRateCard = 'JobOrderRateCard';
    EntityTypes.JobOrderRateCardEditHistory = 'JobOrderRateCardEditHistory';
    EntityTypes.JobOrderRateCardEditHistoryFieldChange = 'JobOrderRateCardEditHistoryFieldChange';
    EntityTypes.JobOrderRateCardEffectiveDateChange = 'JobOrderRateCardEffectiveDateChange';
    EntityTypes.JobOrderRateCardLine = 'JobOrderRateCardLine';
    EntityTypes.JobOrderRateCardLineEditHistoryFieldChange = 'JobOrderRateCardLineEditHistoryFieldChange';
    EntityTypes.JobOrderRateCardLineGroup = 'JobOrderRateCardLineGroup';
    EntityTypes.JobOrderRateCardLineGroupEditHistoryFieldChange = 'JobOrderRateCardLineGroupEditHistoryFieldChange';
    EntityTypes.JobOrderRateCardVersion = 'JobOrderRateCardVersion';
    EntityTypes.JobOrderTemplate = 'JobOrderTemplate';
    EntityTypes.JobShift = 'JobShift';
    EntityTypes.JobShiftAssignment = 'JobShiftAssignment';
    EntityTypes.JobShiftSubmission = 'JobShiftSubmission';
    EntityTypes.JobSubmission = 'JobSubmission';
    EntityTypes.JobSubmissionCertificationRequirement = 'JobSubmissionCertificationRequirement';
    EntityTypes.JobSubmissionCertificationRequirementEditHistory = 'JobSubmissionCertificationRequirementEditHistory';
    EntityTypes.JobSubmissionCertificationRequirementEditHistoryFieldChange = 'JobSubmissionCertificationRequirementEditHistoryFieldChange';
    EntityTypes.JobSubmissionEditHistory = 'JobSubmissionEditHistory';
    EntityTypes.JobSubmissionEditHistoryFieldChange = 'JobSubmissionEditHistoryFieldChange';
    EntityTypes.JobSubmissionHistory = 'JobSubmissionHistory';
    EntityTypes.JobSubmissionIntegration = 'JobSubmissionIntegration';
    EntityTypes.Lead = 'Lead';
    EntityTypes.LeadHistory = 'LeadHistory';
    EntityTypes.LegalBusinessEntity = 'LegalBusinessEntity';
    EntityTypes.LocalTaxForm = 'LocalTaxForm';
    EntityTypes.Location = 'Location';
    EntityTypes.LocationEditHistory = 'LocationEditHistory';
    EntityTypes.LocationEditHistoryFieldChange = 'LocationEditHistoryFieldChange';
    EntityTypes.LocationEffectiveDateChange = 'LocationEffectiveDateChange';
    EntityTypes.LocationVersion = 'LocationVersion';
    EntityTypes.MailListPushHistory = 'MailListPushHistory';
    EntityTypes.MailListPushHistoryDetail = 'MailListPushHistoryDetail';
    EntityTypes.MappedEntityConfiguration = 'MappedEntityConfiguration';
    EntityTypes.MassActionBatch = 'MassActionBatch';
    EntityTypes.MassActionBatchEntity = 'MassActionBatchEntity';
    EntityTypes.MassActionTypeLookup = 'MassActionTypeLookup';
    EntityTypes.Menu = 'Menu';
    EntityTypes.MessageTemplate = 'MessageTemplate';
    EntityTypes.MessageTemplateFileAttachment = 'MessageTemplateFileAttachment';
    EntityTypes.NPSResponse = 'NPSResponse';
    EntityTypes.NPSUserInfo = 'NPSUserInfo';
    EntityTypes.Note = 'Note';
    EntityTypes.NoteEntity = 'NoteEntity';
    EntityTypes.NoteTemplate = 'NoteTemplate';
    EntityTypes.Opportunity = 'Opportunity';
    EntityTypes.Opportunity1 = 'Opportunity1';
    EntityTypes.Opportunity2 = 'Opportunity2';
    EntityTypes.Opportunity3 = 'Opportunity3';
    EntityTypes.Opportunity4 = 'Opportunity4';
    EntityTypes.Opportunity5 = 'Opportunity5';
    EntityTypes.OpportunityCustomObject10EditHistory = 'OpportunityCustomObject10EditHistory';
    EntityTypes.OpportunityCustomObject1EditHistory = 'OpportunityCustomObject1EditHistory';
    EntityTypes.OpportunityCustomObject2EditHistory = 'OpportunityCustomObject2EditHistory';
    EntityTypes.OpportunityCustomObject3EditHistory = 'OpportunityCustomObject3EditHistory';
    EntityTypes.OpportunityCustomObject4EditHistory = 'OpportunityCustomObject4EditHistory';
    EntityTypes.OpportunityCustomObject5EditHistory = 'OpportunityCustomObject5EditHistory';
    EntityTypes.OpportunityCustomObject6EditHistory = 'OpportunityCustomObject6EditHistory';
    EntityTypes.OpportunityCustomObject7EditHistory = 'OpportunityCustomObject7EditHistory';
    EntityTypes.OpportunityCustomObject8EditHistory = 'OpportunityCustomObject8EditHistory';
    EntityTypes.OpportunityCustomObject9EditHistory = 'OpportunityCustomObject9EditHistory';
    EntityTypes.OpportunityCustomObjectEditHistoryFieldChange = 'OpportunityCustomObjectEditHistoryFieldChange';
    EntityTypes.OpportunityCustomObjectInstance1 = 'OpportunityCustomObjectInstance1';
    EntityTypes.OpportunityCustomObjectInstance10 = 'OpportunityCustomObjectInstance10';
    EntityTypes.OpportunityCustomObjectInstance2 = 'OpportunityCustomObjectInstance2';
    EntityTypes.OpportunityCustomObjectInstance3 = 'OpportunityCustomObjectInstance3';
    EntityTypes.OpportunityCustomObjectInstance4 = 'OpportunityCustomObjectInstance4';
    EntityTypes.OpportunityCustomObjectInstance5 = 'OpportunityCustomObjectInstance5';
    EntityTypes.OpportunityCustomObjectInstance6 = 'OpportunityCustomObjectInstance6';
    EntityTypes.OpportunityCustomObjectInstance7 = 'OpportunityCustomObjectInstance7';
    EntityTypes.OpportunityCustomObjectInstance8 = 'OpportunityCustomObjectInstance8';
    EntityTypes.OpportunityCustomObjectInstance9 = 'OpportunityCustomObjectInstance9';
    EntityTypes.OpportunityEditHistory = 'OpportunityEditHistory';
    EntityTypes.OpportunityEditHistoryFieldChange = 'OpportunityEditHistoryFieldChange';
    EntityTypes.OpportunityFileAttachment = 'OpportunityFileAttachment';
    EntityTypes.OpportunityHistory = 'OpportunityHistory';
    EntityTypes.OtherSalesTaxRate = 'OtherSalesTaxRate';
    EntityTypes.OvertimeEarnCode = 'OvertimeEarnCode';
    EntityTypes.PageInteraction = 'PageInteraction';
    EntityTypes.PayBillOptionsLookup = 'PayBillOptionsLookup';
    EntityTypes.PayBillCycle = 'PayBillCycle';
    EntityTypes.PayBillSetting = 'PayBillSetting';
    EntityTypes.PayCheck = 'PayCheck';
    EntityTypes.PayExportBatch = 'PayExportBatch';
    EntityTypes.PayExportBatchExternal = 'PayExportBatchExternal';
    EntityTypes.PayExportTypeLookup = 'PayExportTypeLookup';
    EntityTypes.PayGroupLookup = 'PayGroupLookup';
    EntityTypes.PayMaster = 'PayMaster';
    EntityTypes.PayMasterTransaction = 'PayMasterTransaction';
    EntityTypes.PayMasterTransactionPayExportBatch = 'PayMasterTransactionPayExportBatch';
    EntityTypes.PayMasterTransactionPayExportBatchIssues = 'PayMasterTransactionPayExportBatchIssues';
    EntityTypes.PayTransaction = 'PayTransaction';
    EntityTypes.PayableCharge = 'PayableCharge';
    EntityTypes.PayableChargeEditHistory = 'PayableChargeEditHistory';
    EntityTypes.PayableChargeEditHistoryFieldChange = 'PayableChargeEditHistoryFieldChange';
    EntityTypes.PayableChargeExportedTransaction = 'PayableChargeExportedTransaction';
    EntityTypes.PayableChargePayableTransaction = 'PayableChargePayableTransaction';
    EntityTypes.PayableChargeStatusLookup = 'PayableChargeStatusLookup';
    EntityTypes.PayrollEmployeeTypeLookup = 'PayrollEmployeeTypeLookup';
    EntityTypes.PayrollExportConfig = 'PayrollExportConfig';
    EntityTypes.PayrollExportTargetLookup = 'PayrollExportTargetLookup';
    EntityTypes.PayrollExportTypeLookup = 'PayrollExportTypeLookup';
    EntityTypes.PayrollSyncStatusLookup = 'PayrollSyncStatusLookup';
    EntityTypes.Person = 'Person';
    EntityTypes.PersonCustomObject10EditHistory = 'PersonCustomObject10EditHistory';
    EntityTypes.PersonCustomObject1EditHistory = 'PersonCustomObject1EditHistory';
    EntityTypes.PersonCustomObject2EditHistory = 'PersonCustomObject2EditHistory';
    EntityTypes.PersonCustomObject3EditHistory = 'PersonCustomObject3EditHistory';
    EntityTypes.PersonCustomObject4EditHistory = 'PersonCustomObject4EditHistory';
    EntityTypes.PersonCustomObject5EditHistory = 'PersonCustomObject5EditHistory';
    EntityTypes.PersonCustomObject6EditHistory = 'PersonCustomObject6EditHistory';
    EntityTypes.PersonCustomObject7EditHistory = 'PersonCustomObject7EditHistory';
    EntityTypes.PersonCustomObject8EditHistory = 'PersonCustomObject8EditHistory';
    EntityTypes.PersonCustomObject9EditHistory = 'PersonCustomObject9EditHistory';
    EntityTypes.PersonCustomObjectEditHistoryFieldChange = 'PersonCustomObjectEditHistoryFieldChange';
    EntityTypes.PersonCustomObjectInstance1 = 'PersonCustomObjectInstance1';
    EntityTypes.PersonCustomObjectInstance10 = 'PersonCustomObjectInstance10';
    EntityTypes.PersonCustomObjectInstance11 = 'PersonCustomObjectInstance11';
    EntityTypes.PersonCustomObjectInstance12 = 'PersonCustomObjectInstance12';
    EntityTypes.PersonCustomObjectInstance13 = 'PersonCustomObjectInstance13';
    EntityTypes.PersonCustomObjectInstance14 = 'PersonCustomObjectInstance14';
    EntityTypes.PersonCustomObjectInstance15 = 'PersonCustomObjectInstance15';
    EntityTypes.PersonCustomObjectInstance16 = 'PersonCustomObjectInstance16';
    EntityTypes.PersonCustomObjectInstance17 = 'PersonCustomObjectInstance17';
    EntityTypes.PersonCustomObjectInstance18 = 'PersonCustomObjectInstance18';
    EntityTypes.PersonCustomObjectInstance19 = 'PersonCustomObjectInstance19';
    EntityTypes.PersonCustomObjectInstance2 = 'PersonCustomObjectInstance2';
    EntityTypes.PersonCustomObjectInstance20 = 'PersonCustomObjectInstance20';
    EntityTypes.PersonCustomObjectInstance21 = 'PersonCustomObjectInstance21';
    EntityTypes.PersonCustomObjectInstance22 = 'PersonCustomObjectInstance22';
    EntityTypes.PersonCustomObjectInstance23 = 'PersonCustomObjectInstance23';
    EntityTypes.PersonCustomObjectInstance24 = 'PersonCustomObjectInstance24';
    EntityTypes.PersonCustomObjectInstance25 = 'PersonCustomObjectInstance25';
    EntityTypes.PersonCustomObjectInstance26 = 'PersonCustomObjectInstance26';
    EntityTypes.PersonCustomObjectInstance27 = 'PersonCustomObjectInstance27';
    EntityTypes.PersonCustomObjectInstance28 = 'PersonCustomObjectInstance28';
    EntityTypes.PersonCustomObjectInstance29 = 'PersonCustomObjectInstance29';
    EntityTypes.PersonCustomObjectInstance3 = 'PersonCustomObjectInstance3';
    EntityTypes.PersonCustomObjectInstance30 = 'PersonCustomObjectInstance30';
    EntityTypes.PersonCustomObjectInstance31 = 'PersonCustomObjectInstance31';
    EntityTypes.PersonCustomObjectInstance32 = 'PersonCustomObjectInstance32';
    EntityTypes.PersonCustomObjectInstance33 = 'PersonCustomObjectInstance33';
    EntityTypes.PersonCustomObjectInstance34 = 'PersonCustomObjectInstance34';
    EntityTypes.PersonCustomObjectInstance35 = 'PersonCustomObjectInstance35';
    EntityTypes.PersonCustomObjectInstance4 = 'PersonCustomObjectInstance4';
    EntityTypes.PersonCustomObjectInstance5 = 'PersonCustomObjectInstance5';
    EntityTypes.PersonCustomObjectInstance6 = 'PersonCustomObjectInstance6';
    EntityTypes.PersonCustomObjectInstance7 = 'PersonCustomObjectInstance7';
    EntityTypes.PersonCustomObjectInstance8 = 'PersonCustomObjectInstance8';
    EntityTypes.PersonCustomObjectInstance9 = 'PersonCustomObjectInstance9';
    EntityTypes.Placement = 'Placement';
    EntityTypes.Placement1 = 'Placement1';
    EntityTypes.Placement2 = 'Placement2';
    EntityTypes.Placement3 = 'Placement3';
    EntityTypes.Placement4 = 'Placement4';
    EntityTypes.Placement5 = 'Placement5';
    EntityTypes.PlacementBillRuleset = 'PlacementBillRuleset';
    EntityTypes.PlacementBillRulesetAssociationChangeHistory = 'PlacementBillRulesetAssociationChangeHistory';
    EntityTypes.PlacementBillRulesetEditHistory = 'PlacementBillRulesetEditHistory';
    EntityTypes.PlacementBillRulesetEditHistoryFieldChange = 'PlacementBillRulesetEditHistoryFieldChange';
    EntityTypes.PlacementBillRulesetEffectiveDateChange = 'PlacementBillRulesetEffectiveDateChange';
    EntityTypes.PlacementCertification = 'PlacementCertification';
    EntityTypes.PlacementCertificationEditHistory = 'PlacementCertificationEditHistory';
    EntityTypes.PlacementCertificationEditHistoryFieldChange = 'PlacementCertificationEditHistoryFieldChange';
    EntityTypes.PlacementChangeRequest = 'PlacementChangeRequest';
    EntityTypes.PlacementChangeRequest2 = 'PlacementChangeRequest2';
    EntityTypes.PlacementChangeRequest3 = 'PlacementChangeRequest3';
    EntityTypes.PlacementChangeRequest4 = 'PlacementChangeRequest4';
    EntityTypes.PlacementChangeRequest5 = 'PlacementChangeRequest5';
    EntityTypes.PlacementChangeRequestEditHistory = 'PlacementChangeRequestEditHistory';
    EntityTypes.PlacementChangeRequestEditHistoryFieldChange = 'PlacementChangeRequestEditHistoryFieldChange';
    EntityTypes.PlacementCommission = 'PlacementCommission';
    EntityTypes.PlacementCommissionEditHistory = 'PlacementCommissionEditHistory';
    EntityTypes.PlacementCommissionEditHistoryFieldChange = 'PlacementCommissionEditHistoryFieldChange';
    EntityTypes.PlacementCredentialDetail = 'PlacementCredentialDetail';
    EntityTypes.PlacementCustomObject = 'PlacementCustomObject';
    EntityTypes.PlacementCustomObject10EditHistory = 'PlacementCustomObject10EditHistory';
    EntityTypes.PlacementCustomObject1EditHistory = 'PlacementCustomObject1EditHistory';
    EntityTypes.PlacementCustomObject2EditHistory = 'PlacementCustomObject2EditHistory';
    EntityTypes.PlacementCustomObject3EditHistory = 'PlacementCustomObject3EditHistory';
    EntityTypes.PlacementCustomObject4EditHistory = 'PlacementCustomObject4EditHistory';
    EntityTypes.PlacementCustomObject5EditHistory = 'PlacementCustomObject5EditHistory';
    EntityTypes.PlacementCustomObject6EditHistory = 'PlacementCustomObject6EditHistory';
    EntityTypes.PlacementCustomObject7EditHistory = 'PlacementCustomObject7EditHistory';
    EntityTypes.PlacementCustomObject8EditHistory = 'PlacementCustomObject8EditHistory';
    EntityTypes.PlacementCustomObject9EditHistory = 'PlacementCustomObject9EditHistory';
    EntityTypes.PlacementCustomObjectAttribute = 'PlacementCustomObjectAttribute';
    EntityTypes.PlacementCustomObjectAttributeInteraction = 'PlacementCustomObjectAttributeInteraction';
    EntityTypes.PlacementCustomObjectDepartment = 'PlacementCustomObjectDepartment';
    EntityTypes.PlacementCustomObjectEditHistoryFieldChange = 'PlacementCustomObjectEditHistoryFieldChange';
    EntityTypes.PlacementCustomObjectInstance1 = 'PlacementCustomObjectInstance1';
    EntityTypes.PlacementCustomObjectInstance10 = 'PlacementCustomObjectInstance10';
    EntityTypes.PlacementCustomObjectInstance2 = 'PlacementCustomObjectInstance2';
    EntityTypes.PlacementCustomObjectInstance3 = 'PlacementCustomObjectInstance3';
    EntityTypes.PlacementCustomObjectInstance4 = 'PlacementCustomObjectInstance4';
    EntityTypes.PlacementCustomObjectInstance5 = 'PlacementCustomObjectInstance5';
    EntityTypes.PlacementCustomObjectInstance6 = 'PlacementCustomObjectInstance6';
    EntityTypes.PlacementCustomObjectInstance7 = 'PlacementCustomObjectInstance7';
    EntityTypes.PlacementCustomObjectInstance8 = 'PlacementCustomObjectInstance8';
    EntityTypes.PlacementCustomObjectInstance9 = 'PlacementCustomObjectInstance9';
    EntityTypes.PlacementEditHistory = 'PlacementEditHistory';
    EntityTypes.PlacementEditHistoryFieldChange = 'PlacementEditHistoryFieldChange';
    EntityTypes.PlacementFileAttachment = 'PlacementFileAttachment';
    EntityTypes.PlacementHistory = 'PlacementHistory';
    EntityTypes.PlacementPayRuleset = 'PlacementPayRuleset';
    EntityTypes.PlacementPayRulesetAssociationChangeHistory = 'PlacementPayRulesetAssociationChangeHistory';
    EntityTypes.PlacementPayRulesetEditHistory = 'PlacementPayRulesetEditHistory';
    EntityTypes.PlacementPayRulesetEditHistoryFieldChange = 'PlacementPayRulesetEditHistoryFieldChange';
    EntityTypes.PlacementPayRulesetEffectiveDateChange = 'PlacementPayRulesetEffectiveDateChange';
    EntityTypes.PlacementRateCard = 'PlacementRateCard';
    EntityTypes.PlacementRateCardChangeRequest = 'PlacementRateCardChangeRequest';
    EntityTypes.PlacementRateCardChangeRequestSnapshot = 'PlacementRateCardChangeRequestSnapshot';
    EntityTypes.PlacementRateCardChangeRequestStatusLookup = 'PlacementRateCardChangeRequestStatusLookup';
    EntityTypes.PlacementRateCardEditHistory = 'PlacementRateCardEditHistory';
    EntityTypes.PlacementRateCardEditHistoryFieldChange = 'PlacementRateCardEditHistoryFieldChange';
    EntityTypes.PlacementRateCardEffectiveDateChange = 'PlacementRateCardEffectiveDateChange';
    EntityTypes.PlacementRateCardLine = 'PlacementRateCardLine';
    EntityTypes.PlacementRateCardLineEditHistoryFieldChange = 'PlacementRateCardLineEditHistoryFieldChange';
    EntityTypes.PlacementRateCardLineGroup = 'PlacementRateCardLineGroup';
    EntityTypes.PlacementRateCardLineGroupEditHistoryFieldChange = 'PlacementRateCardLineGroupEditHistoryFieldChange';
    EntityTypes.PlacementRateCardStatusLookup = 'PlacementRateCardStatusLookup';
    EntityTypes.PlacementRateCardVersion = 'PlacementRateCardVersion';
    EntityTypes.PlacementShiftSet = 'PlacementShiftSet';
    EntityTypes.PlacementShiftSetAssociationChangeHistory = 'PlacementShiftSetAssociationChangeHistory';
    EntityTypes.PlacementShiftSetEditHistory = 'PlacementShiftSetEditHistory';
    EntityTypes.PlacementShiftSetEditHistoryFieldChange = 'PlacementShiftSetEditHistoryFieldChange';
    EntityTypes.PlacementShiftSetEffectiveDateChange = 'PlacementShiftSetEffectiveDateChange';
    EntityTypes.PlacementShiftSetVersion = 'PlacementShiftSetVersion';
    EntityTypes.PlacementTaxExemptionStatusLookup = 'PlacementTaxExemptionStatusLookup';
    EntityTypes.PlacementTimeAndExpense = 'PlacementTimeAndExpense';
    EntityTypes.PrivateLabel = 'PrivateLabel';
    EntityTypes.PrivateLabelAttribute = 'PrivateLabelAttribute';
    EntityTypes.PulseConfiguration = 'PulseConfiguration';
    EntityTypes.PulseConfigurationValue = 'PulseConfigurationValue';
    EntityTypes.PurchaseOrder = 'PurchaseOrder';
    EntityTypes.RateDetail = 'RateDetail';
    EntityTypes.RateDetailEditHistory = 'RateDetailEditHistory';
    EntityTypes.RateDetailEditHistoryFieldChange = 'RateDetailEditHistoryFieldChange';
    EntityTypes.RateGroup = 'RateGroup';
    EntityTypes.RateGroupEditHistory = 'RateGroupEditHistory';
    EntityTypes.RateGroupEditHistoryFieldChange = 'RateGroupEditHistoryFieldChange';
    EntityTypes.Report = 'Report';
    EntityTypes.ReportCategory = 'ReportCategory';
    EntityTypes.ReportingCodeTemplate = 'ReportingCodeTemplate';
    EntityTypes.ReportingCodeTemplateEditHistory = 'ReportingCodeTemplateEditHistory';
    EntityTypes.ReportingCodeTemplateEditHistoryFieldChange = 'ReportingCodeTemplateEditHistoryFieldChange';
    EntityTypes.SalesQuota = 'SalesQuota';
    EntityTypes.SalesTaxGroup = 'SalesTaxGroup';
    EntityTypes.SalesTaxRate = 'SalesTaxRate';
    EntityTypes.SalesTaxRateEditHistory = 'SalesTaxRateEditHistory';
    EntityTypes.SalesTaxRateEditHistoryFieldChange = 'SalesTaxRateEditHistoryFieldChange';
    EntityTypes.SalesTaxRateEffectiveDateChange = 'SalesTaxRateEffectiveDateChange';
    EntityTypes.SalesTaxRateSourceLookup = 'SalesTaxRateSourceLookup';
    EntityTypes.SalesTaxRateTypeLookup = 'SalesTaxRateTypeLookup';
    EntityTypes.SalesTaxRateVersion = 'SalesTaxRateVersion';
    EntityTypes.Sendout = 'Sendout';
    EntityTypes.Shift = 'Shift';
    EntityTypes.ShiftPosition = 'ShiftPosition';
    EntityTypes.ShiftSetting = 'ShiftSetting';
    EntityTypes.ShiftType = 'ShiftType';
    EntityTypes.SignatureTemplate = 'SignatureTemplate';
    EntityTypes.Skill = 'Skill';
    EntityTypes.SmsTracking = 'SmsTracking';
    EntityTypes.Specialty = 'Specialty';
    EntityTypes.State = 'State';
    EntityTypes.StateSalesTaxRate = 'StateSalesTaxRate';
    EntityTypes.StateTaxForm = 'StateTaxForm';
    EntityTypes.StatusLookup = 'StatusLookup';
    EntityTypes.StopWord = 'StopWord';
    EntityTypes.SubmissionTemplate = 'SubmissionTemplate';
    EntityTypes.Surcharge = 'Surcharge';
    EntityTypes.SurchargeEditHistory = 'SurchargeEditHistory';
    EntityTypes.SurchargeEditHistoryFieldChange = 'SurchargeEditHistoryFieldChange';
    EntityTypes.SurchargeRate = 'SurchargeRate';
    EntityTypes.SurchargeRateAssociationChangeHistory = 'SurchargeRateAssociationChangeHistory';
    EntityTypes.SurchargeRateEditHistory = 'SurchargeRateEditHistory';
    EntityTypes.SurchargeRateEditHistoryFieldChange = 'SurchargeRateEditHistoryFieldChange';
    EntityTypes.SurchargeRateEffectiveDateChange = 'SurchargeRateEffectiveDateChange';
    EntityTypes.SurchargeRateTypeLookup = 'SurchargeRateTypeLookup';
    EntityTypes.SurchargeRateVersion = 'SurchargeRateVersion';
    EntityTypes.SurchargeRateVersionEarnCode = 'SurchargeRateVersionEarnCode';
    EntityTypes.SurchargeType = 'SurchargeType';
    EntityTypes.Task = 'Task';
    EntityTypes.TaskEditHistory = 'TaskEditHistory';
    EntityTypes.TaskEditHistoryFieldChange = 'TaskEditHistoryFieldChange';
    EntityTypes.TaskTemplate = 'TaskTemplate';
    EntityTypes.Tax = 'Tax';
    EntityTypes.TaxEditHistory = 'TaxEditHistory';
    EntityTypes.TaxEditHistoryFieldChange = 'TaxEditHistoryFieldChange';
    EntityTypes.TaxJurisdictionTypeLookup = 'TaxJurisdictionTypeLookup';
    EntityTypes.TaxStatusLookup = 'TaxStatusLookup';
    EntityTypes.TaxType = 'TaxType';
    EntityTypes.TaxTypeLookup = 'TaxTypeLookup';
    EntityTypes.Tearsheet = 'Tearsheet';
    EntityTypes.TearsheetMember = 'TearsheetMember';
    EntityTypes.TearsheetRecipient = 'TearsheetRecipient';
    EntityTypes.TimeLaborCalcTypeLookup = 'TimeLaborCalcTypeLookup';
    EntityTypes.TimeLaborEvalRule = 'TimeLaborEvalRule';
    EntityTypes.TimeLaborEvalRuleCategoryLookup = 'TimeLaborEvalRuleCategoryLookup';
    EntityTypes.TimeLaborEvalRuleCombineCriteriaLookup = 'TimeLaborEvalRuleCombineCriteriaLookup';
    EntityTypes.TimeLaborEvalRuleStatusLookup = 'TimeLaborEvalRuleStatusLookup';
    EntityTypes.TimeLaborEvalRuleTemplate = 'TimeLaborEvalRuleTemplate';
    EntityTypes.TimeLaborEvalRuleTypeLookup = 'TimeLaborEvalRuleTypeLookup';
    EntityTypes.TimeLaborEvalSheetEntryTypeLookup = 'TimeLaborEvalSheetEntryTypeLookup';
    EntityTypes.TimeLaborEvalSheetStatusLookup = 'TimeLaborEvalSheetStatusLookup';
    EntityTypes.TimeUnit = 'TimeUnit';
    EntityTypes.Timesheet = 'Timesheet';
    EntityTypes.TimesheetEntry = 'TimesheetEntry';
    EntityTypes.TimesheetEntryApprovalStatusLookup = 'TimesheetEntryApprovalStatusLookup';
    EntityTypes.TransactionNote = 'TransactionNote';
    EntityTypes.TransactionNoteType = 'TransactionNoteType';
    EntityTypes.TransactionOrigin = 'TransactionOrigin';
    EntityTypes.TransactionStatus = 'TransactionStatus';
    EntityTypes.TransactionType = 'TransactionType';
    EntityTypes.UnbilledRevenueDistribution = 'UnbilledRevenueDistribution';
    EntityTypes.UnbilledRevenueDistributionBatch = 'UnbilledRevenueDistributionBatch';
    EntityTypes.UnbilledRevenueDistributionGeneralLedgerExportStatusLookup = 'UnbilledRevenueDistributionGeneralLedgerExportStatusLookup';
    EntityTypes.UnitOfMeasure = 'UnitOfMeasure';
    EntityTypes.UserConnectIntegration = 'UserConnectIntegration';
    EntityTypes.UserConnectIntegrationStatusLookup = 'UserConnectIntegrationStatusLookup';
    EntityTypes.UserCustomObject = 'UserCustomObject';
    EntityTypes.UserCustomObjectAttribute = 'UserCustomObjectAttribute';
    EntityTypes.UserCustomObjectAttributeInteraction = 'UserCustomObjectAttributeInteraction';
    EntityTypes.UserCustomObjectDepartment = 'UserCustomObjectDepartment';
    EntityTypes.UserEditHistory = 'UserEditHistory';
    EntityTypes.UserEditHistoryFieldChange = 'UserEditHistoryFieldChange';
    EntityTypes.UserHousingComplexUnit = 'UserHousingComplexUnit';
    EntityTypes.UserIntegration = 'UserIntegration';
    EntityTypes.UserLinkedInUrn = 'UserLinkedInUrn';
    EntityTypes.UserMessage = 'UserMessage';
    EntityTypes.UserMessageFile = 'UserMessageFile';
    EntityTypes.UserPulseCallLog = 'UserPulseCallLog';
    EntityTypes.UserPulseCallLogContact = 'UserPulseCallLogContact';
    EntityTypes.UserSetting = 'UserSetting';
    EntityTypes.UserSurvey = 'UserSurvey';
    EntityTypes.UserSurveyOptions = 'UserSurveyOptions';
    EntityTypes.UserType = 'UserType';
    EntityTypes.WorkersCompensation = 'WorkersCompensation';
    EntityTypes.WorkersCompensationRate = 'WorkersCompensationRate';
    EntityTypes.ZipCodeGis = 'ZipCodeGis';
    return EntityTypes;
}());
exports.EntityTypes = EntityTypes;
